import React, { useState, useEffect, Fragment } from 'react';
import {
  Row,
  Input,
  FormGroup,
  Label,
  CustomInput,
  Button,
  ButtonGroup,
  Form,
  Modal,
  ModalBody,
  InputGroup,
} from 'reactstrap';
import {
  Colxx,
  Separator,
} from '../../../../../../components/common/CustomBootstrap';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import { sortPropertyListByName } from '../../../../../../helpers/Utils';
import {
  gAPI_Property_List_By_Group,
  API_OneNZ_Integration,
} from '../../../../../../constants/APIs';
import {
  ReservationIntegrationsData,
  PreCheckinRequestData,
  HouseKeepingData,
  RegformData,
} from '../../data/OracleOperaFeatures';
import Validation from '../../../../../../components/Validation';
export default function OneNZIntegration({ visible, toggle, id }) {
  const [property, setProperty] = useState([]);
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState([]);
  const [inputData, setInputData] = useState({
    groupId: getGroupID(),
    name: '',
    properties: '',
    sessionTimeoutInSeconds: 600,
    defaultLanguage: 'en-US',
    apiKey: '',
    apiSecret: '',
  });
  const [reservationList, setReservationList] = useState(
    ReservationIntegrationsData
  );
  const [maskData, setMaskData] = useState({
    apiKey: '',
    apiSecret: '',
  });
  const [preCheckinList, setPreCheckinList] = useState(PreCheckinRequestData);
  const [houseKeepingList, setHouseKeepingList] = useState(HouseKeepingData);
  const [RegformList, setRegformList] = useState(RegformData);
  const [selectedReservationList, setSelectedReservationList] = useState([]);
  const [selectedPreCheckinList, setSelectedPreCheckinList] = useState([]);
  const [selectedHouseKeepingList, setSelectedHouseKeepingList] = useState([]);
  const [selectedRegFormList, setSelectedRegFormList] = useState([]);
  const [alertData, setAlertData] = useState([]);
  const [departmentData, setDepartmentData] = useState([]);

  useEffect(() => {
    if (id !== undefined) {
      AxiosAPI({
        method: 'get',
        url: `${API_OneNZ_Integration}/${id}?group_id=${getGroupID()}`,
      })
        .then((res) => {
          // console.log(res.data)
          setInputData({
            ...inputData,
            name: res.data.name,
            properties:
              res.data.properties !== null ? [res.data.properties[0]] : [],
            apiSecret: res.data.oneNZInetgration?.apiSecret,
            apiKey: res.data.oneNZInetgration?.apiKey,
          });
          setMaskData({
            ...maskData,
            apiSecret: mask(res.data.oneNZInetgration?.apiSecret),
            apiKey: mask(res.data.oneNZInetgration?.apiKey),
          });
        })
        .catch((err) => console.log('err', err));

      AxiosAPI({
        method: 'get',
        url: `${gAPI_Property_List_By_Group}/?group_id=${getGroupID()}`,
      })
        .then((res) => {
          setProperty([...res.data]);
        })
        .catch((err) => console.error(err));
    } else {
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Property_List_By_Group}/?group_id=${getGroupID()}`,
      })
        .then((res) => {
          setProperty([...res.data]);
        })
        .catch((err) => console.error(err));
    }
  }, [id]);

  const handleChange = (e) => {
    e.persist();
    setInputData({ ...inputData, [e.target.name]: e.target.value });
    setMaskData({ ...maskData, [e.target.name]: mask(e.target.value) });
  };

  const handleCheckChange = (e) => {
    let filterList = [];
    if (e.target.checked) {
      filterList.push(e.target.value);
    }
    setInputData({ ...inputData, properties: filterList });
  };

  const handleSave = async () => {
    var bodyData = {
      ...inputData,
      features: selectedReservationList.concat(
        selectedPreCheckinList,
        selectedHouseKeepingList,
        selectedRegFormList
      ),
    };
    if (id !== undefined) {
      AxiosAPI({
        method: 'put',
        url: `${API_OneNZ_Integration}/${id}?group_id=${getGroupID()}`,
        data: bodyData,
      }).then((res) => {
        if (
          res.data.HttpStatusCode !== undefined &&
          res.data.HttpStatusCode === 400 &&
          res.data.Messages !== undefined &&
          res.data.Messages !== null &&
          res.data.Messages.length > 0
        ) {
          setMsg(res.data.Messages);
          setOpen(true);
        } else {
          toggle();
          setTimeout(() => {
            window.location.reload();
          }, 300);
        }
      });
    } else {
      AxiosAPI({
        method: 'post',
        url: API_OneNZ_Integration,
        data: bodyData,
      }).then((res) => {
        if (
          res.data.HttpStatusCode !== undefined &&
          res.data.HttpStatusCode === 400 &&
          res.data.Messages !== undefined &&
          res.data.Messages !== null &&
          res.data.Messages.length > 0
        ) {
          setMsg(res.data.Messages);
          setOpen(true);
        } else {
          toggle();
          setTimeout(() => {
            window.location.reload();
          }, 300);
        }
      });
    }
  };
  const mask = (value) => {
    let maskedValue = '';
    for (let i = 0; i < value.length - 2; i++) {
      maskedValue += '*';
    }
    return maskedValue + value.substring(value.length - 2, value.length);
  };
  return (
    <Fragment>
      <Modal isOpen={visible} toggle={toggle} size="lg">
        <ModalBody>
          <Row className="mb-4">
            <Colxx xxs="12">
              <div className="text-center">
                <h6>{id === undefined ? 'Add' : 'Update'} Integration</h6>
              </div>
              <Separator className="mb-3" />
              <Form>
                <Row>
                  <Colxx md="12">
                    <FormGroup className="mb-2">
                      <Label>Integration Name</Label>
                      <Input
                        type="text"
                        name="name"
                        onChange={handleChange}
                        placeholder="Integration Name"
                        defaultValue={inputData.name}
                      />
                    </FormGroup>
                  </Colxx>
                  <Colxx md="6">
                    <FormGroup className="mb-2">
                      <Label>Api Key</Label>
                      <Input
                        type="text"
                        name="apiKey"
                        onChange={handleChange}
                        placeholder="Api Key"
                        defaultValue={maskData?.apiKey}
                      />
                    </FormGroup>
                  </Colxx>
                  <Colxx md="6">
                    <FormGroup className="mb-2">
                      <Label>Api Secret</Label>
                      <Input
                        type="text"
                        name="apiSecret"
                        onChange={handleChange}
                        placeholder="Api Secret"
                        defaultValue={maskData?.apiSecret}
                      />
                    </FormGroup>
                  </Colxx>
                  <Colxx md="12">
                    <FormGroup>
                      <div className="my-2 text-center">
                        <h3>Select your property</h3>
                      </div>
                      <div className="integration-property">
                        {sortPropertyListByName(property).map((p, index) => {
                          return (
                            <CustomInput
                              key={p.id}
                              type="radio"
                              id={index}
                              label={p.name}
                              value={p.id}
                              checked={
                                p.id === inputData?.properties[0] ? true : false
                              }
                              name="property"
                              onChange={handleCheckChange}
                            />
                          );
                        })}
                      </div>
                    </FormGroup>
                  </Colxx>
                </Row>
              </Form>
              <div className="text-center">
                <ButtonGroup
                  className="mb-2 text-center"
                  style={{ marginTop: '20px' }}
                >
                  {id === undefined ? (
                    <Button color="primary" size="xs" onClick={handleSave}>
                      Create New Integration
                    </Button>
                  ) : (
                    <Button color="primary" size="xs" onClick={handleSave}>
                      Update Integration
                    </Button>
                  )}

                  <Button size="xs" color="dark" outline onClick={toggle}>
                    Cancel
                  </Button>
                </ButtonGroup>
              </div>
            </Colxx>
          </Row>
        </ModalBody>
      </Modal>
      <Validation
        open={open}
        messages={msg}
        toggle={() => {
          setOpen(!open);
        }}
      ></Validation>
    </Fragment>
  );
}
